@if ((size$ | async) !== ScreenSizeBreakpointNames.DESKTOP) {
  @if (_isMobileHeaderVisible) {
    <div [@slideFromTop]="imageLoaded ? 1 : 0" class="navigation-header-container mobile">
      <cp-navigation-header-radius-container>
        <div class="image-container">
          @if (companyLogo$ | async) {
            <div class="relative w-100 h-100">
              <img
                class="logo"
                [ngSrc]="companyLogo$ | async"
                fill
                alt="company-logo"
                priority
                (load)="imageLoaded = true" />
            </div>
          } @else {
            <div style="background: white; width: 2rem"></div>
          }
        </div>
      </cp-navigation-header-radius-container>
    </div>

    <div class="layout-fr-fr py-3 px-5 action-buttons">
      <div>
        <button
          *hasCompanyClientUiSettingsEnabled="showProfilePageKey"
          pButton
          class="p-button medium centered"
          [routerLink]="['/', paths.PLATFORM, paths.platform.PROFILE]">
          <shared-icon icon="person" height="1.5rem" width="1.5rem" />
        </button>
      </div>
      @if (companyShowDashboardAdvisorCard$ | async) {
        <div>
          <button
            pButton
            class="p-button medium centered ml-auto"
            [routerLink]="[
              '/',
              paths.PLATFORM,
              paths.platform.PROFILE,
              paths.platform.profile.ADVISOR,
            ]">
            <shared-icon icon="call-chat" height="1.5rem" width="1.5rem" />
          </button>
        </div>
      }
    </div>
  }
}

<ng-template #companyLogo>
  <cp-navigation-header-radius-container>
    <div class="image-container">
      @if (companyLogo$ | async) {
        <div class="relative w-100 h-100">
          <img #logo class="logo" [ngSrc]="companyLogo$ | async" fill alt="company-logo" priority />
        </div>
      } @else {
        <div style="background: white; width: 2rem"></div>
      }
    </div>
  </cp-navigation-header-radius-container>
</ng-template>
